import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, withDefaults, watch } from 'vue';


export interface PropsOptions {
	hidden: boolean,
	filename: string|null,
}



export default /*#__PURE__*/_defineComponent({
  __name: 'IDEViewerContentTypeUnknown',
  props: {
    hidden: { type: Boolean },
    filename: null
  },
  setup(__props: any) {

const props = __props as { hidden: boolean, filename: string|null }





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["IDEViewerContentTypeUnknown", {hidden: __props.hidden}])
  }, " Obsah tohoto typu souboru nelze zobrazit ", 2))
}
}

})